import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting";

export default {
  getPackSizeDetails(id) {
    return Repository.get(`${resource}/pack-sizes/${id}`)
  },
  getListOfPackSize(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/pack-sizes?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  // getListOfCcpNoPagination(filterQuery) {
  //   return Repository.get(`${resource}/ccp_items?is_paginate=0&${filterQuery}`)
  // },
  createPackSize(payload) {
    return Repository.post(`${resource}/pack-sizes`, payload)
  },
  deletePackSize(id) {
    return Repository.delete(`${resource}/pack-sizes/${id}`)
  },
  updatePackSize(id, payload) {
    return Repository.put(`${resource}/pack-sizes/${id}`, payload)
  }
};
